module.exports = __webpack_public_path__ + "static/media/3.154f933d.jpg";